import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
//Css
import "./Css/App.css";
import "./Css/main.css";
import "./Css/responsive.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//Pages
import Home from "./Pages/HomePage/Home";
import Career from "./Pages/CareerPage/Career";
import AppDevelopment from "./Pages/ServicePage/AppDevelopment/AppDevelopment";
import CustomSoftware from "./Pages/ServicePage/CustomSoftware/CustomSoftware.jsx";
import WebDev from "./Pages/ServicePage/WebDev/WebDev.jsx";
import DevelopersForHire from "./Pages/ServicePage/DevelopersForHire/DevelopersForHire.jsx";
import DataAnalysis from "./Pages/ServicePage/DataAnalysis/DataAnalysis.jsx";
import NewFooter from "./Pages/Footer/NewFooter";
import Navbar from "./Pages/HomePage/NavBar/Navbar.jsx";
import BlogDetailsFirst from "./Pages/Blog-Pages/Blog-Details_V1/BlogDetails-1.js";
import BlogDetailsSecond from "./Pages/Blog-Pages/Blog-Detials_V2/BlogDetails-2.js";
import BlogDetailsThird from "./Pages/Blog-Pages/Blog-Details_V3/BlogDetails-3.js";
import TechlogiesPage from "./Pages/TechlogiesPage/TechlogiesPage.jsx";
import TechUI from "./Pages/TechlogiesPage/TechUI.jsx";
import TechDb from "./Pages/TechlogiesPage/TechDb.jsx";
import TechCloud from "./Pages/TechlogiesPage/TechCloud.jsx";
import TechMobile from "./Pages/TechlogiesPage/TechMobile.jsx";
import TechWeb from "./Pages/TechlogiesPage/TechWeb.jsx";
import Consulting from "./Pages/ServicePage/Consulting/Consulting.jsx";
import Contact from "./Pages/ContactPage/ContactPage.jsx";
import BuildBusiness from "./Pages/Contact/BuildBusiness.jsx";
import StartHiringDev from "./Pages/Contact/StartHiringDev.jsx";
import BlogDetailsFourth from "./Pages/Blog-Pages/Blog-Details_V4/Blog-Details_V4.js";
import BlogDetailsFifth from "./Pages/Blog-Pages/Blog-Details_V5/Blog-Details_V5.js";

function App() {
  return (
    <div>
      <React.StrictMode>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/Home" element={<Home />} />

            <Route path="/blog1" element={<BlogDetailsFourth />} />
            <Route path="/blog2" element={<BlogDetailsFifth />} />
            <Route path="/blog3" element={<BlogDetailsThird />} />
            {/* <Route path="/blog4" element={<BlogDetailsFourth />} />
            <Route path="/blog5" element={<BlogDetailsFifth />} /> */}
            <Route path="/Career" element={<Career />} />
            <Route path="/careers" element={<Career />} />

            <Route path="/contact-us" element={<Contact></Contact>} />
            <Route
              path="/contact-us/build-business"
              element={<BuildBusiness></BuildBusiness>}
            />
            <Route
              path="/contact-us/hiring-team"
              element={<StartHiringDev> </StartHiringDev>}
            />

            {/* services route */}
            <Route
              path="/services/mobile-app-development"
              element={<AppDevelopment />}
            />
            <Route
              path="/services/custom-software-development"
              element={<CustomSoftware />}
            />
            <Route path="/services/web-development" element={<WebDev />} />
            <Route
              path="/services/software-consulting"
              element={<Consulting />}
            />
            <Route
              path="/services/developers-for-hire"
              element={<DevelopersForHire />}
            />
            <Route path="/services/data-analytics" element={<DataAnalysis />} />

            {/* technologies pages */}
            <Route path="/technologies" element={<TechlogiesPage />} />
            <Route path="/technologies/web" element={<TechWeb />} />
            <Route path="/technologies/mobile" element={<TechMobile />} />
            <Route path="/technologies/ui-ux" element={<TechUI />} />
            <Route path="/technologies/cloud" element={<TechCloud />} />
            <Route path="/technologies/database" element={<TechDb />} />
          </Routes>

          <NewFooter></NewFooter>
        </BrowserRouter>
      </React.StrictMode>
    </div>
  );
}

export default App;
